import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Icon } from "../../../Icon/index.js";
import { useIsDesktop } from "../../../hooks/index.js";
import { Box } from "../../../Box/index.js";
import { ButtonGroup } from "../../../ButtonGroup/index.js";
import { Button } from "../../../Button/index.js";
import { useStyles } from "../Preview.styles.js";
import { doDownload } from "./download/download.js";
import { DownloadButton } from "./DownloadButton.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const PreviewButtons = ({ pdf, withCollapsableFooter, onClickDownload, onClickPrint, clickable })=>{
    const isDesktop = useIsDesktop();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isPrinting, setIsPrinting] = useState(false);
    const { classes } = useStyles({});
    const handleDownloadClick = ()=>_async_to_generator(function*() {
            if (pdf) {
                setIsLoading(true);
                setError(null);
            }
            if (!onClickDownload) return;
            const handlerRes = yield onClickDownload();
            if ('object' == typeof handlerRes && 'file' in handlerRes) doDownload(handlerRes.file, handlerRes.filename || 'document').then(()=>{
                if (pdf) setIsLoading(false);
            }, (e)=>{
                if (pdf) {
                    setError(e);
                    setIsLoading(false);
                }
            });
            else doDownload(handlerRes, 'documents.zip').then(()=>{
                if (pdf) setIsLoading(false);
            }, (e_0)=>{
                if (pdf) {
                    setError(e_0);
                    setIsLoading(false);
                }
            });
        })();
    const handlePrintClick = ()=>_async_to_generator(function*() {
            if (!pdf || !onClickPrint) return;
            setIsPrinting(true);
            try {
                yield onClickPrint();
            } finally{
                setIsPrinting(false);
            }
        })();
    if (([
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform) || navigator.userAgent.includes('Mac') && 'ontouchend' in document) && navigator.userAgent.match('CriOS')) return null;
    const buttons = [
        ...isDesktop && onClickPrint ? [
            /*#__PURE__*/ jsx(Button, {
                icon: /*#__PURE__*/ jsx(Icon, {
                    name: "printer_outline",
                    size: "24"
                }),
                onClick: handlePrintClick,
                loading: isPrinting,
                disabled: isPrinting
            }, "print")
        ] : [],
        /*#__PURE__*/ jsx(Button, {
            icon: /*#__PURE__*/ jsx(Icon, {
                name: "download_outline",
                size: "24"
            }),
            loading: isLoading,
            disabled: isLoading,
            onClick: handleDownloadClick
        }, "download")
    ];
    const buttonGroup = pdf && !error ? /*#__PURE__*/ jsx(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: "20",
        className: classes.previewButtons,
        children: /*#__PURE__*/ jsx(ButtonGroup, {
            size: isDesktop ? 'large' : 'small',
            orientation: isDesktop ? 'horizontal' : 'vertical',
            separated: !isDesktop,
            onClick: (event)=>event.stopPropagation(),
            children: buttons
        })
    }) : null;
    return withCollapsableFooter ? /*#__PURE__*/ jsx(DownloadButton, {
        onClick: handleDownloadClick,
        clickable: clickable
    }) : buttonGroup;
};
export { PreviewButtons };
